
export interface ChatMessage {
  id: string;
  sender: 'user' | 'bot';
  text: string;
  timestamp: Date;
  mainUrl?: { obj: string; val: string };
  otherUrl?: { obj: string; val: string }[];
}
import { RoleFormValues } from '@/components/performerRoles/AddWorkflowPerformerRole';
import { apiWorkflow, authClient, AuthUser, codeManagerClient, RefreshTokenResponse } from './api-client';
import { PartnerForm } from '@/shared/formPortalSchema';
import { Code, MainType, Type } from '@/shared/schema';
import { TeamFormValues } from '@/components/performerTeam/AddWorkflowPerformerTeam';



// ==================== TYPE DEFINITIONS ====================
export interface Product {
  id: number;
  name: string;
  description: string;
  price: number;
  category: string;
  stock: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateProductDto {
  name: string;
  description: string;
  price: number;
  category: string;
  stock: number;
}

export interface UpdateProductDto extends Partial<CreateProductDto> { }

export interface PaginatedResponse<T> {
  items: T[];
  meta: {
    total: number;
    page: number;
    page_size: number;
  }
}

export interface PaginatedData<T> {
  items: T[];
  total: number;
  page: number;
  page_size: number;
}

export interface PaginatedHubRes {
  data: string;
  success: boolean;
  status: string;
  message: string;
}

export interface PortalForm {
  Id: number;
  FormId: number;
  FormCode: string;
  Version: number;
  FormPartnerType: number;
  FormName: string;
  FormType: string;
  FormPartnerName: string;
  SchemaJson: string | null;
  IsActive: boolean;
  Published: boolean;
}

export interface WorkflowPayload {
  Name: string;
  Description: string;
  IsSubprocess: boolean;
  Type: string;
  AddedBy: string;
  Status: number;
  AppID: number;
  ExchangePartner: number;
  WorkFlowSubCategory: number;
  WorkFlowEntity: number;
}

export interface WorkflowTemplatePayload {
  name: string;
  description: string;
  phase: string;
  workflow_key: string;
}

export interface WorkflowTeamsRes {
  id: number;
  teamName: string;
  teamDesc: string;
  workflowAssignment: string;
  createdAt: string;
  lastModified: string;
}

export interface WorkflowTeamsAction {
  id: number;
  roleType: number;
  roleTypeType: string | null;
  roleTypeName: string | null;
  roleName: string;
  userPermission: boolean;
  totalEntry: number;
  decryptData: boolean;
  description: string;
  dateTimeAdded: string;
  lastModified: string | null;
}

export interface InterfacePayload {
  description: string;
  implementStatus?: boolean;
  input: string;
  name: string;
  output: string;
  type: number;
  repositoryInterfaceId: number | null;
}

export interface checkInData {
  UserName: string;
  Comment: string;
}

export interface IntExtInterfacePayload {
  description: string;
  name: string;
  repositoryInterfaceId: number | null;
}

export interface intExtPayload {
  ids: number[]
}

export interface WorkflowCheckInOut {
  Id: number;
  PMId: number;
  WFId: number;
  WorkflowName: string;
  CheckInDate: string | null;
  CheckInBy: string | null;
  CheckInComments: string | null;
  CheckOutDate: string | null;
  CheckOutBy: string | null;
  CheckOutComments: string | null;
  Version: number;
}

export interface WorkflowAction {
  PMId: number;
  WFId: number;
  WorkflowName: string;
  ProcessType: string;
  WorkflowType: string;
  Description: string;
  Status: number;
  VersionNumber: number;
  isActive: number;
  LastUser: string;
  DateCreated: string;
  LastModified: string;
  ExchangePartner: number | null;
  WorkFlowSubCategory: number;
  WorkFlowEntity: number;
  ExchangePartner_Name: string | null;
  WorkFlowSubCategory_Name: string;
  WorkFlowEntity_Name: string;
}

export interface WorkflowRoleRes {
  message: string,
  id: number
}

export interface WorkflowRoleEditRes {
  message: string,
}

export interface WorkflowVersionResponse {
  PMId: number;
  WFId: number;
  Status: number;
  VersionNumber: number;
  LastUser: string;
  Comment: string;
  ChangedAt: string;
}

export interface activeToggleResponse {
  PMId: number;
  isActive: number;
}

export interface InterfaceAction {
  Id: number;
  name: string;
  path: string | null;
  type: number;
  input: string;
  useFlag: boolean | null;
  dateTimeChanged: string;
  changedBy: string | null;
  output: string;
  addedBy: string | null;
  applicationID: number | null;
  description: string;
  displaySequence: number | null;
  internalInterfaceType: number | null;
  repositoryInterfaceId: number | null;
  status: boolean;
  implementStatus: boolean;
}

export interface CreateUserDto {
  name: string;
  email: string;
  password: string;
  role: string;
}

export type GetFormDefinitionsParams = {
  page: number;
  pageSize: number;
  formType: string;
  q?: string;
  formCode?: string | number;
  formName?: string;
  partnerType?: string;
  offerId?: string | null
};

export type GetWorkflowParams = {
  page: number;
  pageSize?: number;
  intId?: string;
  intName?: string;
  intType?: string | undefined;
};

export type GetIntExtInterfaceParams = {
  page: number;
  pageSize: number;
  InterfaceId?: string;
  InterfaceName?: string;
  InterfaceType: string | undefined;
};

export interface UpdateUserDto extends Partial<Omit<CreateUserDto, 'password'>> {
  password?: string;
}

export type GetPartnersParams = {
  pageNumber: number,
  pageSize?: number,
  partnerName?: string,
  partnerType?: string,
  partnerSubType?: string,
};

export interface ApiResponse<T> {
  data: T;
  message: string;
  success: boolean;
}

export interface PartnerData {
  items: PartnerForm[],
  page_no: number,
  page_size: number,
  total: number,
  total_pages: number
}

export interface AuditLogEntry {
  timestamp: string;
  error_type: string;
  status_code: number;
  error_message: string;
  response_time_ms: number;
  [key: string]: unknown;
}

export interface AuditDebugInfo {
  audit_log_dir: string;
  audit_log_dir_absolute: string;
  audit_log_dir_exists: boolean;
  available_dates: string[];
  entries_after_filter: number;
  entries_before_filter: number;
  log_file_absolute_path: string;
  log_file_exists: boolean;
  log_file_path: string;
  target_date: string;
}

export interface AuditFilters {
  start_date: string | null;
  end_date: string | null;
  error_type: string | null;
  status_code: number | null;
}

export interface AuditData {
  date: string;
  debug: AuditDebugInfo;
  logs: AuditLogEntry[];
  filters: AuditFilters;
  limit: number;
  offset: number;
  page: number;
  total: number;
}



// ==================== BPRM AUTH SERVICES ====================
export const authService = {
  me: async (): Promise<AuthUser> => {
    const response = await authClient.get<AuthUser>('/auth/me');
    return response.data;
  },

  refresh: async (): Promise<RefreshTokenResponse> => {
    const response = await authClient.post<RefreshTokenResponse>('/auth/refresh');
    return response.data;
  },

  logout: async (): Promise<{ success: boolean; message: string }> => {
    const response = await authClient.post('/auth/logout');
    return response.data;
  },

  offerFormId: async (id: number, referenceFormId: number): Promise<{ success: boolean; message: string, data: any }> => {
    console.log("referenceFormId", referenceFormId)
    const response = await authClient.put(`/partner-service/api/exchange-offers/${id}/reference-form`, { ReferenceFormId: referenceFormId });
    return response.data;
  },

  additionalOfferFormId: async (id: number, additionalOfferId: number, referenceFormId: number): Promise<{ success: boolean; message: string, data: any }> => {
    console.log("referenceFormId", referenceFormId)
    const response = await authClient.put(`/partner-service/api/exchange-offers/${id}/additional-offers/${additionalOfferId}/reference-form`, { ReferenceFormId: referenceFormId });
    return response.data;
  },
};



// ==================== BPRM SERVICES ====================
export const partnerService = {
  getPartnersData: async ({ pageNumber, pageSize, partnerName, partnerType, partnerSubType, }: GetPartnersParams): Promise<ApiResponse<PartnerData>> => {
    const params = new URLSearchParams({
      page: pageNumber.toString(),
    });

    if (pageSize) {
      params.append("pageSize", pageSize.toString());
    }
    if (partnerName && partnerName.trim()) {
      params.append("partnerName", partnerName);
    }
    if (partnerType && partnerType.trim()) {
      params.append("partnerType", partnerType);
    }
    if (partnerSubType && partnerSubType) {
      params.append("partnerSubType", partnerSubType);
    }

    const response = await authClient.get(`/partner-service/api/partnerforms?${params.toString()}&includeInactive=false`)
    return response.data;
  }
}



// ==================== All WORKFLOW APIs ===============
export const codeService = {
  listTypes: async (name?: number, types?: string, parentType?: string, parentCode?: string): Promise<Code[]> => {

    const params = new URLSearchParams();
    if (name !== undefined) params.append("name", String(name));
    if (types) params.append("type", types);
    if (parentType) params.append("parentType", parentType);
    if (parentCode) params.append("parentCode", parentCode);
    params.append("includeDeleted", "false");

    const response = await codeManagerClient.get(`/catalog/filter?${params.toString()}`)
    return response.data;
  },

  getPhases: async (): Promise<any[]> => {
    const response = await codeManagerClient.get(`/catalog/filter?type=Phases&includeDeleted=false`);
    return response.data;
  },

  getPhaseChildren: async (phaseName: string): Promise<any> => {
    const response = await apiWorkflow.get(`/api/workflow-library/${encodeURIComponent(phaseName)}`);
    return response.data;
  },

}



// ==================== All WORKFLOW APIs ===============
export const workflowRepo = {
  chatWithAI: async (
    message: string,
    sessionId?: string,
    microservice: string = "workflow",
    page: number = 1
  ): Promise<{ assistantReply: string; sessionId: string; messages?: any[]; hasMore?: boolean; totalMessages?: number }> => {
    const payload: any = { microservice };
    if (message) payload.message = message;
    if (sessionId) payload.sessionId = sessionId;

    const response = await authClient.post(`/assistant/chat?page=${page}`, payload);
    return response.data;
  },
  getWorkflowData: async ({
    page = 1,
    pageSize,
    intId,
    intName,
    intType,
  }: GetWorkflowParams): Promise<PaginatedData<WorkflowAction>> => {
    const params = new URLSearchParams();

    params.append("page", String(page));
    if (pageSize) params.append("page_size", String(pageSize));
    if (intName) params.append("name", intName);
    if (intId) params.append("id", intId);
    if (intType) params.append("status", intType);

    const response = await apiWorkflow.get<PaginatedData<WorkflowAction>>(
      `/api/workflows?${params.toString()}&include_deleted=false&sort_by=Id&sort_dir=desc`
    );
    return response.data;
  },

  createWorkflowData: async (data: RoleFormValues): Promise<WorkflowAction> => {
    const response = await apiWorkflow.post<WorkflowAction>(`/api/workflows`, data);
    return response.data;
  },

  editWorkflowData: async (Id: number, data: WorkflowPayload): Promise<WorkflowAction> => {
    const response = await apiWorkflow.put<WorkflowAction>(`/api/workflows/${Id}`, data);
    return response.data;
  },

  deleteWorkflowData: async (Id: number): Promise<InterfaceAction> => {
    const response = await apiWorkflow.delete<InterfaceAction>(`/api/workflows/${Id}`);
    return response.data;
  },

  checkInOutWorkflow: async (Id: number, data: checkInData): Promise<WorkflowVersionResponse> => {
    const response = await apiWorkflow.post<WorkflowVersionResponse>(`/api/workflows/${Id}/toggle-check-status`, data);
    return response.data;
  },

  activateInActiveWorkflow: async (Id: number): Promise<activeToggleResponse> => {
    const response = await apiWorkflow.post<activeToggleResponse>(`/api/workflows/${Id}/toggle-active`);
    return response.data;
  },

  getWorkflowVersionsData: async (Id: number): Promise<WorkflowCheckInOut[]> => {
    const response = await apiWorkflow.get<WorkflowCheckInOut[]>(`/api/workflows/${Id}/versions?include_deleted=false&sort_by=Version&sort_dir=desc`);
    return response.data;
  },



  //Roles
  getWorkflowTeamsRole: async ({
    page = 1,
    pageSize,
    intId,
    intName,
    intType,
  }: GetWorkflowParams): Promise<PaginatedData<WorkflowTeamsAction>> => {
    const params = new URLSearchParams();

    params.append("page_no", String(page));
    if (pageSize) params.append("page_size", String(pageSize));
    if (intId) params.append("id", intId);
    if (intType) params.append("userpermission", intType);
    if (intName) params.append("name", intName);

    const response = await apiWorkflow.get<PaginatedData<WorkflowTeamsAction>>(
      `api/performer-roles?${params.toString()}`
    );
    return response.data;
  },

  createWorkflowRole: async (data: RoleFormValues): Promise<WorkflowRoleRes> => {
    const response = await apiWorkflow.post<WorkflowRoleRes>(`/api/performer-roles`, data);
    return response.data;
  },

  editWorkflowRole: async (Id: number, data: RoleFormValues): Promise<WorkflowRoleEditRes> => {
    const response = await apiWorkflow.put<WorkflowRoleEditRes>(`/api/performer-roles/${Id}`, data);
    return response.data;
  },

  deleteWorkflowRole: async (Id: number): Promise<WorkflowRoleEditRes> => {
    const response = await apiWorkflow.delete<WorkflowRoleEditRes>(`/api/performer-roles/${Id}`);
    return response.data;
  },



  //Teams
  getWorkflowTeamsTeam: async ({
    page = 1,
    pageSize,
    intId,
    intName,
  }: GetWorkflowParams): Promise<PaginatedData<WorkflowTeamsRes>> => {
    const params = new URLSearchParams();

    params.append("page", String(page));
    if (pageSize) params.append("pageSize", String(pageSize));
    if (intId) params.append("id", intId);
    if (intName) params.append("teamName", intName);

    const response = await apiWorkflow.get<PaginatedData<WorkflowTeamsRes>>(
      `/api/teams?${params.toString()}`
    );
    return response.data;
  },

  createWorkflowTeam: async (data: TeamFormValues): Promise<WorkflowRoleRes> => {
    const response = await apiWorkflow.post<WorkflowRoleRes>(`/api/teams`, data);
    return response.data;
  },

  editWorkflowTeam: async (Id: number, data: TeamFormValues): Promise<WorkflowRoleEditRes> => {
    const response = await apiWorkflow.put<WorkflowRoleEditRes>(`/api/teams/${Id}`, data);
    return response.data;
  },

  deleteWorkflowTeam: async (Id: number): Promise<WorkflowRoleEditRes> => {
    const response = await apiWorkflow.delete<WorkflowRoleEditRes>(`/api/teams/${Id}`);
    return response.data;
  },

  createFormAI: async (prompt: string): Promise<MainType> => {
    const response = await apiWorkflow.post<MainType>(`ai/workflows`, { prompt });
    return response.data
  },

  createWorkflowTemplate: async (data: WorkflowTemplatePayload): Promise<any> => {
    const response = await apiWorkflow.post(`/api/workflow-library`, data);
    return response.data;
  },

  chatWorkflowAPI: async (payload: any = {}): Promise<any> => {
    const response = await apiWorkflow.post(`/api/workflow/message`, payload);
    return response.data;
  }
,

  searchEntities: async ({
    type,
    name,
    page = 1,
    pageSize = 20,
  }: {
    type: "Workflows" | "Roles" | "Teams";
    name?: string;
    page?: number;
    pageSize?: number;
  }): Promise<{ items: string[]; rawItems: any[]; total: number; hasMore: boolean }> => {
    const params = new URLSearchParams();
    params.append("type", type);
    if (name && name.trim()) {
      params.append("name", name.trim());
    }
    params.append("page", String(page));
    params.append("page_size", String(pageSize));

    const response = await apiWorkflow.get(`/api/search?${params.toString()}`);
    const data = response.data;

    let rawList: any[] = [];
    let totalCount = 0;

    if (Array.isArray(data)) {
      rawList = data;
      totalCount = data.length;
    } else if (data && Array.isArray(data.items)) {
      rawList = data.items;
      totalCount = typeof data.total === "number" ? data.total : 0;
    } else if (data && Array.isArray(data.data)) {
      rawList = data.data;
      totalCount = typeof data.total === "number" ? data.total : (data.totalCount ?? 0);
    } else if (data && data.data && Array.isArray(data.data.items)) {
      rawList = data.data.items;
      totalCount = typeof data.data.total === "number" ? data.data.total : 0;
    } else if (data && Array.isArray(data.results)) {
      rawList = data.results;
      totalCount = typeof data.total === "number" ? data.total : 0;
    }

    const extractName = (item: any): string => {
      if (typeof item === "string") return item;
      if (!item) return "";
      return (
        item.name ||
        item.Name ||
        item.workflowName ||
        item.WorkflowName ||
        item.roleName ||
        item.RoleName ||
        item.teamName ||
        item.TeamName ||
        item.label ||
        item.title ||
        String(item.id ?? item.Id ?? "")
      );
    };

    const names = rawList
      .map(extractName)
      .map((s) => (typeof s === "string" ? s.trim() : ""))
      .filter((n) => n.length > 0);

    const hasMore = rawList.length >= pageSize && (totalCount > 0 ? page * pageSize < totalCount : true);

    return {
      items: names,
      rawItems: rawList,
      total: totalCount,
      hasMore,
    };
  }
};
